export const AnnouncementContentKind = {
    Info: 'Info',
    NewVersion: 'NewVersion',
    FirstSteps: 'FirstSteps',
    BackgroundTaskStarted: 'BackgroundTaskStarted',
    BackgroundTaskEnded: 'BackgroundTaskEnded',
    ExpiringLicenses: 'ExpiringLicenses',
    NewOnlineReceiverAvailable: 'NewOnlineReceiverAvailable',
    DocumentEmailDeliveryFailure: 'DocumentEmailDeliveryFailure',
    UnsettledDocumentReminderDeliveryFailure: 'UnsettledDocumentReminderDeliveryFailure',
    DataExchangeEmailDeliveryFailure: 'DataExchangeEmailDeliveryFailure',
    DocumentTemplatesDeactivated: 'DocumentTemplatesDeactivated',
    DocumentTemplateIssuingFailure: 'DocumentTemplateIssuingFailure',
    KsefProcessingEnded: 'KsefProcessingEnded',
    KsefReceivingEnded: 'KsefReceivingEnded',
    KsefReceivingFailed: 'KsefReceivingFailed',
    KsefReceivingStoppedDueToInsufficientFunds: 'KsefReceivingStoppedDueToInsufficientFunds',
    KsefExchangeLimitExceeded: 'KsefExchangeLimitExceeded',
    KsefSendingStoppedDueToInsufficientFunds: 'KsefSendingStoppedDueToInsufficientFunds',
    BackgroundDataPreparationPending: 'BackgroundDataPreparationPending'
} as const;

export type AnnouncementContentKind = typeof AnnouncementContentKind[keyof typeof AnnouncementContentKind];
